import React from 'react'
import PropTypes from 'prop-types'
import AutoSizer from 'react-virtualized-auto-sizer'
import { Choropleth } from '@nivo/geo'
import { transparentize } from 'polished'
import { formatToNumberWithCommas, initializeArrayWithRange } from 'helpers'
import { COLOR_CONSTANTS, colors } from 'theme'
import GraphTooltip from './GraphTooltip'

const getColors = () =>
  initializeArrayWithRange(5, 1)
    .map((index) => {
      const transparency = 0 + index * 0.1
      return transparentize(transparency, colors.primary)
    })
    .reverse()

const getScaleFromDimensions = ({ width, height, id }) => {
  if (id === 'USA') {
    if (height === 420) {
      return { scale: 700, top: 500, left: 1200 }
    } else {
      if (width < 380) {
        return { scale: width * 0.8, top: width / 1.6, left: width / 0.75 }
      }
      return { scale: width / 2.5, top: width / 4, left: width / 1.4 }
    }
  } else if (height === 420) {
    return { scale: width / 10.5, top: 85 }
  } else {
    if (width < 380) {
      return { scale: width / 6.75, top: width <= 320 ? 50 : width / 7.6 }
    }
    return { scale: 60, top: 50 }
  }
}

const ChoroplethChart = ({ data, map, onClick }) => {
  const { id, features } = map
  const maxValue = 1000 // Math.max.apply(null, data.map(({ value }) => value))
  return (
    <AutoSizer>
      {({ width, height }) => {
        const { scale, top, left } = getScaleFromDimensions({ width, height, id })
        return (
          <Choropleth
            width={width}
            height={height}
            data={data}
            features={features}
            domain={[0, maxValue]}
            margin={{ top, right: 0, bottom: 0, left: left || 0 }}
            unknownColor={COLOR_CONSTANTS.SOLITUDE}
            projectionScale={scale}
            onClick={onClick}
            fillColor={COLOR_CONSTANTS.SOLITUDE}
            colors={getColors()}
            tooltip={({
              feature: {
                formattedValue,
                properties: { name },
              },
            }) => {
              return (
                <GraphTooltip
                  label={name}
                  value={formattedValue ? formatToNumberWithCommas(formattedValue) : '0'}
                  hasBoxShadow
                />
              )
            }}
          />
        )
      }}
    </AutoSizer>
  )
}

ChoroplethChart.defaultProps = {
  onClick: () => {},
}

ChoroplethChart.propTypes = {
  data: PropTypes.array.isRequired,
  map: PropTypes.object.isRequired,
  onClick: PropTypes.func,
}

export default ChoroplethChart
